{
  "reviewStatus": "proposal",
  "note": "Recurring cast (spec §5, OPEN_QUESTIONS #3, #5). Names and biographies are placeholders for the owner to replace. 'friend' and 'parent' are resolved per campaign. Ids of players are the ids used on the field. `roles` name the teammates the story arc leans on (striker, organiser, keeper, newcomer): arc content addresses them by role so shared scenes read the same in both campaigns while still pointing at real roster identities. `school` lists the classmates the Story Engine v2 school hub uses: `rival` is the classmate who plays for a rival club (friend in class, opponent on Saturday), `teacher` runs the classroom activities, and the shared classmates fill recess games.",
  "shared": [
    {
      "id": "coach",
      "name": "Coach Code",
      "role": "coach",
      "clubId": "batavia",
      "shirt": null,
      "bio": "Strict, loud, passionate, demanding, detail-oriented and compassionate; funny; listens; admits mistakes; no grudges when players leave.",
      "reviewStatus": "proposal"
    },
    {
      "id": "sonoran-coach",
      "name": "Coach Delgado",
      "role": "coach",
      "clubId": "sonoran",
      "shirt": null,
      "bio": "Sonoran United U12 head coach and the club's recruiter. Polished, persuasive, promises more than the roster can hold.",
      "reviewStatus": "proposal"
    },
    {
      "id": "camelback-coach",
      "name": "Coach Whitfield",
      "role": "coach",
      "clubId": "camelback",
      "shirt": null,
      "bio": "Camelback Athletic technical director. Former winger; judges everyone by their first touch and means it kindly.",
      "reviewStatus": "proposal"
    },
    {
      "id": "mesaverde-coach",
      "name": "Coach Nakamura",
      "role": "coach",
      "clubId": "mesaverde",
      "shirt": null,
      "bio": "Mesa Verde SC U12 coach. Calm, asks about school before soccer, keeps every promise small enough to keep.",
      "reviewStatus": "proposal"
    },
    {
      "id": "saguaro-coach",
      "name": "Coach Bell",
      "role": "coach",
      "clubId": "saguaro",
      "shirt": null,
      "bio": "Saguaro Rangers coach and PE teacher. Plays everyone, travels nowhere, promises nothing.",
      "reviewStatus": "proposal"
    },
    {
      "id": "redrock-coach",
      "name": "Coach Okafor",
      "role": "coach",
      "clubId": "redrock",
      "shirt": null,
      "bio": "Red Rock FC academy coach, ex-professional goalkeeper. Blunt about evidence; warm once you have some.",
      "reviewStatus": "proposal"
    },
    {
      "id": "teacher",
      "name": "Ms. Ferreira",
      "role": "teacher",
      "clubId": null,
      "shirt": null,
      "bio": "Fifth-grade teacher. Notices who helps and who takes over; grades the group, not the loudest voice.",
      "reviewStatus": "proposal"
    },
    {
      "id": "cm-leah",
      "name": "Leah Brandt",
      "role": "player",
      "clubId": null,
      "shirt": null,
      "bio": "Classmate. Plays rec on Sundays, fearless in recess games, laughs at her own misses.",
      "reviewStatus": "proposal"
    },
    {
      "id": "cm-tobias",
      "name": "Tobias Meyer",
      "role": "player",
      "clubId": null,
      "shirt": null,
      "bio": "Classmate and reliable group-project partner. Reads a lot, kicks a ball like he is apologising to it.",
      "reviewStatus": "proposal"
    },
    {
      "id": "cm-hana",
      "name": "Hana Lim",
      "role": "player",
      "clubId": "camelback",
      "shirt": 7,
      "bio": "Classmate at Camelback Athletic. Quiet, quick, never says which club she plays for unless asked.",
      "reviewStatus": "proposal"
    },
    {
      "id": "cm-ravi",
      "name": "Ravi Anand",
      "role": "player",
      "clubId": null,
      "shirt": null,
      "bio": "Classmate. Commentates every recess game as if it were televised.",
      "reviewStatus": "proposal"
    },
    {
      "id": "cm-sol",
      "name": "Sol Abara",
      "role": "player",
      "clubId": null,
      "shirt": null,
      "bio": "Classmate. Tall, left-footed, only shoots with the left.",
      "reviewStatus": "proposal"
    }
  ],
  "campaigns": {
    "boys": {
      "friend": {
        "id": "friend",
        "name": "Mateo Aldana",
        "role": "player",
        "clubId": "batavia",
        "shirt": 8,
        "bio": "Best friend since second grade. Already at FC Batavia; talks fast, passes early, hates losing at anything.",
        "reviewStatus": "proposal"
      },
      "parent": {
        "id": "parent",
        "name": "Dad",
        "role": "parent",
        "clubId": null,
        "shirt": null,
        "bio": "Works shifts; supportive but careful about money and time. Wants school to come first.",
        "reviewStatus": "proposal"
      },
      "rival": {
        "id": "rival",
        "name": "Dario Quintero",
        "role": "player",
        "clubId": "sonoran",
        "shirt": 10,
        "bio": "Sits two desks over. Sonoran United's number 10 and the best player at recess by a distance. Funny, generous with praise when he means it, and unable to lose quietly. Not a villain: a classmate who wants the same thing you do.",
        "reviewStatus": "proposal"
      },
      "teammates": [
        { "id": "bat-owen", "name": "Owen Petrakis", "role": "player", "clubId": "batavia", "shirt": 1, "bio": "Quiet keeper who wants to play outfield.", "reviewStatus": "proposal" },
        { "id": "bat-dev", "name": "Dev Ramaswamy", "role": "player", "clubId": "batavia", "shirt": 2, "bio": "Fast, brave, forgets to look inside.", "reviewStatus": "proposal" },
        { "id": "bat-luis", "name": "Luis Ortega", "role": "player", "clubId": "batavia", "shirt": 3, "bio": "Left-footed, plays the whole match at one speed.", "reviewStatus": "proposal" },
        { "id": "bat-cal", "name": "Cal Whitfield", "role": "player", "clubId": "batavia", "shirt": 4, "bio": "Tallest on the team, talks a lot, organises without being asked.", "reviewStatus": "proposal" },
        { "id": "bat-sam", "name": "Sam Okafor", "role": "player", "clubId": "batavia", "shirt": 6, "bio": "Reads the game early; nervous in front of goal.", "reviewStatus": "proposal" },
        { "id": "bat-jonah", "name": "Jonah Reyes", "role": "player", "clubId": "batavia", "shirt": 7, "bio": "Tricks first, decisions later; the team's joker.", "reviewStatus": "proposal" },
        { "id": "bat-theo", "name": "Theo Lindqvist", "role": "player", "clubId": "batavia", "shirt": 9, "bio": "Scores in training, freezes in matches; older brother plays for Sonoran.", "reviewStatus": "proposal" },
        { "id": "bat-ari", "name": "Ari Novak", "role": "player", "clubId": "batavia", "shirt": 11, "bio": "New to the area; lives near the training field.", "reviewStatus": "proposal" }
      ],
      "roles": { "striker": "bat-theo", "organiser": "bat-cal", "keeper": "bat-owen", "newcomer": "bat-ari" }
    },
    "girls": {
      "friend": {
        "id": "friend",
        "name": "Nia Okonkwo",
        "role": "player",
        "clubId": "batavia",
        "shirt": 8,
        "bio": "Best friend since kindergarten. Already at FC Batavia; competitive, dry sense of humour, keeps a notebook of set plays.",
        "reviewStatus": "proposal"
      },
      "parent": {
        "id": "parent",
        "name": "Mom",
        "role": "parent",
        "clubId": null,
        "shirt": null,
        "bio": "Runs a small business; drives a lot; worries about schoolwork and burnout.",
        "reviewStatus": "proposal"
      },
      "rival": {
        "id": "rival",
        "name": "Priya Sethi",
        "role": "player",
        "clubId": "sonoran",
        "shirt": 10,
        "bio": "Sits two desks over. Sonoran United's number 10 and the best player at recess by a distance. Dry, exact, generous with praise when she means it, and unable to lose quietly. Not a villain: a classmate who wants the same thing you do.",
        "reviewStatus": "proposal"
      },
      "teammates": [
        { "id": "bat-rosa", "name": "Rosa Delgado", "role": "player", "clubId": "batavia", "shirt": 1, "bio": "Keeper by choice; loudest voice on the field.", "reviewStatus": "proposal" },
        { "id": "bat-kai", "name": "Kai Tanaka", "role": "player", "clubId": "batavia", "shirt": 2, "bio": "Fast, brave, forgets to look inside.", "reviewStatus": "proposal" },
        { "id": "bat-maya", "name": "Maya Brennan", "role": "player", "clubId": "batavia", "shirt": 3, "bio": "Left-footed, plays the whole match at one speed.", "reviewStatus": "proposal" },
        { "id": "bat-imani", "name": "Imani Carter", "role": "player", "clubId": "batavia", "shirt": 4, "bio": "Tallest on the team; organises without being asked.", "reviewStatus": "proposal" },
        { "id": "bat-sofia", "name": "Sofia Marquez", "role": "player", "clubId": "batavia", "shirt": 6, "bio": "Reads the game early; nervous in front of goal.", "reviewStatus": "proposal" },
        { "id": "bat-lena", "name": "Lena Kowalski", "role": "player", "clubId": "batavia", "shirt": 7, "bio": "Tricks first, decisions later; the team's joker.", "reviewStatus": "proposal" },
        { "id": "bat-zoe", "name": "Zoe Haddad", "role": "player", "clubId": "batavia", "shirt": 9, "bio": "Scores in training, freezes in matches; older sister plays for Sonoran.", "reviewStatus": "proposal" },
        { "id": "bat-june", "name": "June Park", "role": "player", "clubId": "batavia", "shirt": 11, "bio": "New to the area; lives near the training field.", "reviewStatus": "proposal" }
      ],
      "roles": { "striker": "bat-zoe", "organiser": "bat-imani", "keeper": "bat-rosa", "newcomer": "bat-june" }
    }
  }
}
